export default __webpack_public_path__ + "31909e139d03bc16182d2c100b95f231.svg";